import './LoadingSpinner.scss';

import clsx from 'clsx';
import React from 'react';

import { cn } from '@/util/ui';

export const TEST_ID = 'spinner';

type LoadingSpinnerProps = {
  spinnerClasses?: string;
  isAbsolute?: boolean;
};

const LoadingSpinner = ({
  spinnerClasses = '',
  isAbsolute = false,
}: LoadingSpinnerProps) => {
  return (
    <div
      className={clsx(
        'screenLoader--container',
        'tw-h-full tw-w-full',
        'tw-bg-cfo-grey-100',
        isAbsolute && 'tw-opacity-20'
      )}
      data-testid={TEST_ID}
    >
      <div
        className={cn(
          'ld-spinner',
          'tw-absolute tw-inset-0',
          'tw-h-full tw-w-full',
          'tw-flex tw-items-center tw-justify-center',
          spinnerClasses
        )}
      >
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
  );
};

export default LoadingSpinner;
